import SEOTestPage from '../../components/SEOTestPage';
import { SEO_TESTS } from '../../data/seoTestsConfig';
export default function KisaSureliHafizaTestiPage() {
  return <SEOTestPage testConfig={SEO_TESTS['kisa-sureli-hafiza-belirtileri-testi']} />;
}
